module.exports = __webpack_public_path__ + "static/media/abb-logo-charcoal.7e2c058f.svg";